import React, { useCallback, useMemo } from 'react';
import { TableInstance } from 'react-table';

import { DeliveryNote } from '@work4all/models/lib/Classes/DeliveryNote.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTable, IEntityTable } from './entity-table/EntityTable';
import { useEntityDataTable } from './entity-table/use-entity-data-table';
import { useCloneConvertErp } from './offers-table/hooks/use-clone-convert-erp';
import schema from './schemata/deliveryNote-table-schema.json';
import { useErpHandlersTemplate } from './use-erp-handlers-template';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];
const FORCE_REQUEST_FIELDS: DeliveryNote<EMode.query> = {
  positionList: [{ id: null, originalId: null }],
};

export const DeliveryNotesTable = React.forwardRef<TableInstance, IEntityTable>(
  function DeliveryNotesTable(_props, ref) {
    const { prepareRowDisplayModifiers, ...dataTable } = useEntityDataTable<
      DeliveryNote,
      never
    >({
      schema: schema as never,
      defaultSort,
      forceRequestFields: FORCE_REQUEST_FIELDS,
    });

    const template = useErpHandlersTemplate();
    const rowModifiers = useCallback(
      (value: DeliveryNote) => {
        const modifiers = prepareRowDisplayModifiers(value);
        return {
          ...modifiers,
          isFaded: value.isClosed && value.frozen,
          isShade1: !value.isClosed && value.frozen,
        };
      },
      [prepareRowDisplayModifiers]
    );

    const { actions } = useCloneConvertErp({
      entity: Entities.deliveryNote,
    });

    const custom = useMemo(
      () => ({
        left: actions,
      }),
      [actions]
    );

    return (
      <EntityTable
        ref={ref}
        template={template}
        {...dataTable}
        actions={{
          custom,
        }}
        prepareRowDisplayModifiers={rowModifiers}
      />
    );
  }
);
